import React, { memo } from 'react';
import { Button } from 'reactstrap';

type Props = {
  amount: number,
  currency: string,
  onClick: () => void,
  buttonText: string,
};

/**
 * This component is used in review pages of
 * SelfGuided   @see src/screens/Trek/SelfGuided/Review/Review
 * Guided Treks @see src/screens/Trek/Guided/Review/Review
 * LodgeDetails @see src/screens/Lodge/LodgeDetails
 */

const CostFooter = ({
  currency = 'USD',
  amount = 0,
  onClick,
  buttonText = 'Buy This Trek',
}: Props) => (
  <div className="gt-mobile">
    <h3>
      TOTAL AMOUNT
      <br />
      <span>
        {currency} {Number(amount).toLocaleString()}
      </span>
    </h3>
    <Button color="compare" onClick={onClick}>
      {buttonText}
    </Button>
  </div>
);

export default memo(CostFooter);



// WEBPACK FOOTER //
// ./src/components/CostFooter/CostFooter.js